export const orders = {
  orders: "products/order/store/",
  change_status: (id: number) => `products/order/store/?id=${id}`,
  get_all_payments: "products/payment/store/",
};
